import { render, staticRenderFns } from "./InvoicesOrPayments.vue?vue&type=template&id=12d2a73a&scoped=true&"
import script from "./InvoicesOrPayments.vue?vue&type=script&lang=js&"
export * from "./InvoicesOrPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2a73a",
  null
  
)

export default component.exports